import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  TextField,
  CircularProgress
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface StylistCreationStepProps {
  useBusinessEmail: boolean;
  setUseBusinessEmail: (value: boolean) => void;
  stylistEmail: string;
  setStylistEmail: (value: string) => void;
  isLoading?: boolean;
}

const StylistCreationStep: React.FC<StylistCreationStepProps> = ({
  useBusinessEmail,
  setUseBusinessEmail,
  stylistEmail,
  setStylistEmail,
  isLoading
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        {t('quickListingWizard.createStylist')}
      </Typography>

      {isLoading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
          <CircularProgress />
        </Box>
      )}

      <FormControlLabel
        control={
          <Checkbox
            checked={useBusinessEmail}
            onChange={(e) => setUseBusinessEmail(e.target.checked)}
            disabled={isLoading}
          />
        }
        label={t('quickListingWizard.useBusinessEmail')}
      />

      {!useBusinessEmail && (
        <TextField
          fullWidth
          margin="normal"
          label={t('quickListingWizard.stylistEmail')}
          type="email"
          value={stylistEmail}
          onChange={(e) => setStylistEmail(e.target.value)}
          required
          disabled={isLoading}
        />
      )}
    </Box>
  );
};

export default StylistCreationStep;
